<template>
  <div class="card card-custom card-transparent">
    <div class="card-body p-0">
      <!--begin: Wizard-->
      <div
          class="wizard wizard-4"
          id="kt_wizard_v4"
          data-wizard-state="step-first"
          data-wizard-clickable="true"
      >
        <!--begin: Wizard Nav-->
        <div class="wizard-nav">
          <div class="wizard-steps">
            <div
                class="wizard-step"
                data-wizard-type="step"
                data-wizard-state="current"
            >
              <div class="wizard-wrapper">
                <div class="wizard-number">
                  1
                </div>
                <div class="wizard-label">
                  <div class="wizard-title">
                    {{ $t('offer_delivery.cart_info') }}
                  </div>
                  <div class="wizard-desc">
                    {{ $t('offer_delivery.cart_info_desc') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-number">
                  2
                </div>
                <div class="wizard-label">
                  <div class="wizard-title">
                    {{ $t('offer_delivery.profiling') }}
                  </div>
                  <div class="wizard-desc">
                    {{ $t('offer_delivery.profiling_desc') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-number">
                  3
                </div>
                <div class="wizard-label">
                  <div class="wizard-title">
                    {{ $t('offer_delivery.design') }}
                  </div>
                  <div class="wizard-desc">
                    {{ $t('offer_delivery.design_desc') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-number">
                  4
                </div>
                <div class="wizard-label">
                  <div class="wizard-title">
                    {{ $t('offer_delivery.delivery') }}
                  </div>
                  <div class="wizard-desc">
                    {{ $t('offer_delivery.delivery_desc') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Nav -->

        <!--begin: Wizard Body-->
        <div class="card card-custom card-shadowless rounded-top-0">
          <div class="card-body p-0">
            <div class="container-fluid justify-content-center">
              <div class="col-xl-12 col-xxl-12 mb-10">
                <!--begin: Wizard Form-->
                <form class="form mt-0 mt-lg-10" id="kt_form">
                  <!--begin: Wizard Step 1-->
                  <div
                      class="pb-5"
                      data-wizard-type="step-content"
                      data-wizard-state="current"
                  >
                    <div class="row">
                      <div class="col-xl-6">
                        <b-form-group
                            :label="$t('offer_delivery.cart_name')"
                            label-for="input-1"
                        >
                          <b-form-input
                              v-model="form.cart_name"
                              type="text"
                              required
                              class="form-control form-control-solid"
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-xl-6">
                        <b-form-group :label="$t('offer_delivery.last_action_date')" label-for="input-2">
                          <b-form-input
                              class="form-control form-control-solid"
                              v-model="form.date"
                              type="date"
                              required
                          ></b-form-input>
                        </b-form-group>
                      </div>
                      <div class="col-xl-6">
                        <div class="separator separator-dashed my-6"></div>
                        <h3 class="font-size-lg text-dark font-weight-bold mb-6">{{ $t('offer_delivery.random_point') }}</h3>
                        <div class="row">
                          <div class="col-xl-4">
                            <b-form-group :label="$t('offer_delivery.random_point_question')">
                              <b-form-checkbox
                                  switch
                                  class="mr-n2 switch switch-outline switch-icon switch-primary"
                                  v-model="random_point_question"
                                  @change="changeItRandom($event)"
                              >
                                <span class="sr-only"></span>
                              </b-form-checkbox>
                            </b-form-group>
                          </div>
                          <div class="col-xl-4">
                            <b-form-group :label="$t('offer_delivery.number_of_people')">
                              <b-form-input
                                  class="form-control form-control-solid"
                                  type="number"
                                  :disabled="number_of_people_status"
                                  v-model="form.number_of_people">
                              </b-form-input>
                            </b-form-group>
                          </div>
                          <div class="col-xl-4">
                            <b-form-group :label="$t('offer_delivery.extra_points')">
                              <b-form-input
                                  class="form-control form-control-solid"
                                  type="number"
                                  :disabled="extra_points_status"
                                  v-model="form.extra_points">
                              </b-form-input>
                            </b-form-group>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="separator separator-dashed my-6"></div>
                        <h3 class="font-size-lg text-dark font-weight-bold mb-6">{{ $t('offer_delivery.survey_information') }}</h3>
                        <div v-if="random_survey_type == 2" class="row">
                          <div class="col-xl-6">
                            <b-form-group
                                :label="$t('offer_delivery.participants')"
                            >
                              <b-form-select
                                  class="form-control form-control-solid"
                                  v-model="form.participants"
                                  :options="participants"
                              ></b-form-select>
                            </b-form-group>
                          </div>
                          <div class="col-xl-6">
                            <b-form-group
                                :label="$t('offer_delivery.project')"
                                label-for="input-1"
                            >
                              <b-form-select
                                  class="form-control form-control-solid"
                                  v-model="form.project"
                                  :options="project"
                              ></b-form-select>
                            </b-form-group>
                          </div>
                        </div>
                        <b-row v-if="random_survey_type == 3">
                          <b-col xl="12">
                            <b-form-group label="Base Anket Link'i">
                              <b-form-input
                                  value="https://online.tr.nielsenconsumer.com/surveyStart.espx?guid=d5ea554e-af24-faa-base-16aa45e945&mid={MGUID}"
                                  type="text"
                                  required
                                  class="form-control form-control-solid"
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row v-if="random_survey_type == 1">
                          <b-col xl="12">
                            <h4 class="font-size-lg text-dark font-weight-bold mb-6">Müşteri Listesine Anket Bilgileri</h4>
                            <b-row>
                              <b-col xl="6">
                                <b-form-group label="E-Posta">
                                  <b-form-input
                                      value=""
                                      size="sm"
                                      type="text"
                                      required
                                      class="form-control form-control-solid"
                                  ></b-form-input>
                                </b-form-group>
                              </b-col>
                              <b-col xl="6">
                                <b-form-group label="Görünen İsim">
                                  <b-form-input
                                      value=""
                                      size="sm"
                                      type="text"
                                      required
                                      class="form-control form-control-solid"
                                  ></b-form-input>
                                </b-form-group>
                              </b-col>
                              <b-col xl="6">
                                <b-button size="sm" v-b-modal.links>Havuz Link Grubunu Düzenle</b-button>

                                <b-modal :cancel-title="$t('general.cancel')" :ok-title="$t('general.save')" size="lg" id="links" title="Linkler">
                                  <b-tabs content-class="mt-3">
                                    <b-tab title="Kullanılan" active>
                                      <b-table striped hover :items="links"></b-table>
                                    </b-tab>
                                    <b-tab title="Kullanılmayan">
                                      <b-table striped hover :items="links"></b-table>
                                    </b-tab>
                                    <b-tab title="Yükle">
                                      <b-form-group label="Lütfen linklerin yükleneceği TXT dosyasını seçin." label-for="file-default" label-cols-sm="12">
                                        <b-form-file id="file-default" placeholder="Dosya seçiniz" browse-text="Seçim yap"></b-form-file>
                                      </b-form-group>
                                    </b-tab>
                                    <b-tab title="Kullanılmayanları Sil">
                                      ....
                                    </b-tab>
                                  </b-tabs>
                                </b-modal>
                              </b-col>
                              <b-col xl="6">
                                <b-button size="sm">Eşleştir</b-button>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </div>
                      <div class="col-xl-6">
                        <div class="separator separator-dashed my-6"></div>
                        <h3 class="font-size-lg text-dark font-weight-bold mb-6">{{ $t('offer_delivery.survey_score_title') }}</h3>
                        <div class="row">
                          <div class="col-xl-6">
                            <b-form-group :label="$t('offer_delivery.survey_score_text')">
                              <b-form-checkbox
                                  switch
                                  class="mr-n2 switch switch-outline switch-icon switch-primary"
                                  v-model="survey_score"
                                  @change="changeIt($event)"
                              >
                                <span class="sr-only"></span>
                              </b-form-checkbox>
                            </b-form-group>
                          </div>
                          <div class="col-xl-6">
                            <b-form-group :label="$t('offer_delivery.completion')">
                              <b-form-input
                                  class="form-control form-control-solid"
                                  type="number"
                                  :disabled="completion_status"
                                  v-model="form.completion"></b-form-input>
                            </b-form-group>
                          </div>
                          <div class="col-xl-6">
                            <b-form-group :label="$t('offer_delivery.screen_out')">
                              <b-form-input
                                  class="form-control form-control-solid"
                                  type="number"
                                  :disabled="screen_out_status"
                                  v-model="form.screen_out"></b-form-input>
                            </b-form-group>
                          </div>
                          <div class="col-xl-6">
                            <b-form-group :label="$t('offer_delivery.cup')">
                              <b-form-input
                                  class="form-control form-control-solid"
                                  type="number"
                                  :disabled="cup_status"
                                  v-model="form.cup"></b-form-input>
                            </b-form-group>
                          </div>
                        </div>
                      </div>

                      <div class="col-xl-6">
                        <div class="row">
                          <div class="col-xl-9">
                            <div class="separator separator-dashed my-6"></div>
                            <b-form-group>
                              <b-form-checkbox
                                  id="profile_fullness"
                                  v-model="form.profile_fullness"
                                  name="profile_fullness"
                                  value="accepted"
                                  unchecked-value="not_accepted"
                              >
                                {{ $t('offer_delivery.profile_fullness') }}
                              </b-form-checkbox>
                              <small>{{$t('offer_delivery.profile_fullness_desc')}}</small>
                            </b-form-group>
                          </div>
                          <div class="col-xl-3">
                            <div class="separator separator-dashed my-6"></div>
                            <b-form-group>
                              <b-form-checkbox
                                  id="live_pool"
                                  v-model="form.live_pool"
                                  name="live_pool"
                                  value="accepted"
                                  unchecked-value="not_accepted"
                              >
                                {{ $t('offer_delivery.live_pool') }}
                              </b-form-checkbox>
                            </b-form-group>
                          </div>

                          <div class="col-xl-12 text-center">
                            <div class="separator separator-dashed my-6"></div>
                            <b-form-group>
                              <b-button variant="outline-primary"><i class="fas fa-magic"></i>{{$t('offer_delivery.id_match')}}</b-button>
                              <b-button variant="outline-primary" class="ml-5"><i class="fas fa-magic"></i>{{$t('offer_delivery.voter_id_match')}}</b-button>
                            </b-form-group>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <!--end: Wizard Step 1-->

                  <!--begin: Wizard Step 2-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <b-row>
                      <b-col xl="6" class="mt-5">
                        <h3 class="font-size-lg text-dark font-weight-bold">
                          <span>{{ $t('offer_delivery.profiling') }}</span>
                        </h3>
                      </b-col>
                      <b-col xl="6" class="mt-1">
                        <bt-button-group class="fa-pull-right">
                          <b-button size="sm" class="mr-2" variant="outline-secondary" v-b-modal.submissions><i class="fas fa-mail-bulk"></i> {{ $t('offer_delivery.delivery_excluding') }}</b-button>
                          <b-button size="sm" variant="outline-secondary" v-b-modal.user_excluding><i class="fas fa-user-friends"></i> {{ $t('offer_delivery.user_excluding') }}</b-button>
                        </bt-button-group>
                      </b-col>
                      <b-col xl="12 mt-3">
                        <div class="separator separator-dashed mb-5"></div>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col xl="12">
                        <Profiling></Profiling>
                      </b-col>
                    </b-row>

                    <b-modal id="submissions" size="lg" hide-footer :title="$t('offer_delivery.delivery_excluding')">
                      <b-form-group :label="$t('offer_delivery.projects')">
                        <b-form-select
                            class="form-control form-control-solid"
                            v-model="form.submissions"
                            :options="submissions"
                            @change="submissionChange"
                        ></b-form-select>
                      </b-form-group>
                      <v-multiselect-listbox :options="multiselect_options"></v-multiselect-listbox>
                      <div class="separator separator-dashed mt-5 mb-5"></div>
                      <div class="row">
                        <div class="col-xl-6">
                          <b-form-group :label="$t('offer_delivery.include_exclude')">
                            <b-form-radio-group
                                v-model="form.including_excluding"
                                :options="including_excluding"
                                name="radio-inline"
                            ></b-form-radio-group>
                          </b-form-group>
                        </div>
                        <div class="col-xl-6">
                          <b-form-group :label="$t('offer_delivery.options')">
                            <b-form-checkbox
                                v-for="(option, index) in submissions_options"
                                :key="index"
                                v-model="form.option_selected"
                                :value="option"
                                :name="option"
                            >
                              {{ option }}
                            </b-form-checkbox>
                          </b-form-group>
                        </div>
                      </div>
                    </b-modal>
                    <b-modal id="user_excluding" size="lg" :ok-title="$t('general.save')" :cancel-title="$t('general.cancel')" :title="$t('offer_delivery.user_excluding')">

                      <b-row>
                        <b-col xl="6" offset-xl="6">
                          Hariç Bırakılacaklar
                        </b-col>
                        <b-col xl="12">
                          <v-multiselect-listbox :options="user_excluding"></v-multiselect-listbox>
                        </b-col>
                        <b-col xl="12">
                          <br>
                          <b-form-group label="Popup Görünümü">
                            <b-form-radio-group
                                v-model="form.popup_status"
                                :options="['Göster', 'Gösterme']"
                                name="radio-inline"
                            ></b-form-radio-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-modal>

                    <b-modal id="id_upload" size="lg" hide-footer :title="$t('offer_delivery.id_upload')">
                      <div class="row">
                        <div class="col-xl-6">
                          <h3 class="font-size-lg text-dark font-weight-bold">
                            <span>{{ $t('offer_delivery.voter_guid_upload') }}</span>
                          </h3>
                          <div class="separator separator-dashed mt-5 mb-5"></div>
                          <b-form-group>
                            <b-form-file :placeholder="$t('general.file_upload')" id="file-default"></b-form-file>
                          </b-form-group>
                          <b-form-group :label="$t('offer_delivery.search_options')">
                            <b-form-radio-group
                                v-model="form.search_settings"
                                :options="search_settings"
                                name="radio-inline"
                            ></b-form-radio-group>
                          </b-form-group>
                          <div class="separator separator-dashed mt-5 mb-5"></div>
                          <strong>{{ $t('general.total') }} :</strong>
                          <strong class="fa-pull-right"> 24</strong>
                        </div>
                        <div class="col-xl-6">
                          <h3 class="font-size-lg text-dark font-weight-bold">
                            <span>{{ $t('offer_delivery.member_id_upload') }}</span>
                          </h3>
                          <div class="separator separator-dashed mt-5 mb-5"></div>
                          <b-form-group>
                            <b-form-file :placeholder="$t('general.file_upload')" id="file-default"></b-form-file>
                          </b-form-group>
                          <b-form-group :label="$t('offer_delivery.search_options')">
                            <b-form-radio-group
                                v-model="form.search_settings_1"
                                :options="search_settings_1"
                                name="radio-inline"
                            ></b-form-radio-group>
                          </b-form-group>
                          <div class="separator separator-dashed mt-5 mb-5"></div>
                          <strong>{{ $t('general.total') }} :</strong>
                          <strong class="fa-pull-right"> 17</strong>
                        </div>
                      </div>
                    </b-modal>

                  </div>
                  <!--end: Wizard Step 2-->

                  <!--begin: Wizard Step 3-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <div class="row">
                      <div class="col-xl-12 mb-10" >
                        <b-button-group size="sm" class="fa-pull-right">
                          <b-button><i class="far fa-save"></i> {{$t('offer_delivery.apply')}}</b-button>
                          <b-button><i class="far fa-window-restore"></i> {{$t('offer_delivery.apply_template')}}</b-button>
                          <b-button><i class="far fa-list-alt"></i> {{$t('offer_delivery.show_all_template')}}</b-button>
                          <b-button><i class="fas fa-broom"></i> {{ $t('offer_delivery.reset') }}</b-button>
                        </b-button-group>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>{{ $t('offer_delivery.template') }}</label>
                          <div class="separator separator-dashed mb-4"></div>
                          <prism-editor
                              class="my-editor"
                              v-model="code"
                              :highlight="highlighter"
                              :line-numbers="lineNumbers"
                          ></prism-editor>
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>{{ $t('offer_delivery.preview') }}</label>
                          <div class="separator separator-dashed mb-4"></div>
                          <div class="imac">
                            <div id="result" v-html="code"></div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-8">
                        <h3 class="font-size-lg text-dark font-weight-bold mb-6">{{ $t('offer_delivery.links') }}</h3>
                        <div class="separator separator-dashed my-6"></div>
                        <b-table
                            :bordered="table.bordered"
                            :outlined="table.outlined"
                            :small="table.small"
                            :hover="table.hover"
                            :fixed="table.fixed"
                            :items="table.items2"
                            :head-variant="table.headvariant"
                        ></b-table>
                      </div>
                      <div class="col-xl-4">
                        <h3 class="font-size-lg text-dark font-weight-bold mb-6">{{ $t('offer_delivery.warnings') }}</h3>
                        <div class="separator separator-dashed my-6"></div>
                        <b-table
                            :bordered="table.bordered"
                            :outlined="table.outlined"
                            :small="table.small"
                            :hover="table.hover"
                            :fixed="table.fixed"
                            :items="table.items5"
                            :head-variant="table.headvariant"
                        ></b-table>
                      </div>
                    </div>
                  </div>
                  <!--end: Wizard Step 3-->

                  <!--begin: Wizard Step 4-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <div class="row">
                      <div class="col-md-6">
                        <h3 class="font-size-lg text-dark font-weight-bold">
                          <span>{{ $t('offer_delivery.real_deliveries') }}</span>
                          <b-dropdown id="dropdown-1" class="fa-pull-right" :text="$t('offer_delivery.action')" size="sm">
                            <b-dropdown-item>{{ $t('offer_delivery.start') }}</b-dropdown-item>
                            <b-dropdown-item disabled>{{ $t('offer_delivery.stop') }}</b-dropdown-item>
                            <b-dropdown-item>{{ $t('general.delete') }}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item>{{ $t('offer_delivery.edit') }}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item v-b-modal.load_data>{{ $t('offer_delivery.show_loaded_data') }}</b-dropdown-item>
                            <b-dropdown-item v-b-modal.profiling_modal>{{$t('offer_delivery.show_profiling')}}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item disabled>{{ $t('offer_delivery.create_a_reminder') }}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item>{{ $t('offer_delivery.refresh') }}</b-dropdown-item>
                            <b-dropdown-item>{{ $t('offer_delivery.incomplete_a_reminder') }}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item>{{ $t('offer_delivery.close_project') }}</b-dropdown-item>
                            <b-dropdown-item>{{ $t('offer_delivery.open_project') }}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item>{{ $t('offer_delivery.show_used_test_ids') }}</b-dropdown-item>
                            <b-dropdown-item>{{ $t('offer_delivery.list_refno') }}</b-dropdown-item>
                            <b-dropdown-item disabled>{{ $t('offer_delivery.delete_participation_records') }}</b-dropdown-item>
                          </b-dropdown>
                        </h3>
                        <div class="separator separator-dashed mt-10 mb-5"></div>
                        <b-table
                            :bordered="table.bordered"
                            :outlined="table.outlined"
                            :small="table.small"
                            :hover="table.hover"
                            :fixed="table.fixed"
                            :items="table.items3"
                            :head-variant="table.headvariant"
                        ></b-table>
                      </div>
                      <div class="col-md-6">
                        <h3 class="font-size-lg text-dark font-weight-bold">
                          <span>{{ $t('offer_delivery.internal_test_deliveries') }}</span>
                          <b-dropdown id="dropdown-1" class="fa-pull-right" :text="$t('offer_delivery.action')" size="sm">
                            <b-dropdown-item v-b-modal.internal_test_post>{{ $t('offer_delivery.add_internal_test_post') }}</b-dropdown-item>
                            <b-dropdown-item>{{ $t('offer_delivery.start') }}</b-dropdown-item>
                            <b-dropdown-item disabled>{{ $t('offer_delivery.stop') }}</b-dropdown-item>
                            <b-dropdown-item>{{ $t('general.delete') }}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item>{{ $t('offer_delivery.edit') }}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item v-b-modal.load_data>{{ $t('offer_delivery.show_loaded_data') }}</b-dropdown-item>
                            <b-dropdown-item v-b-modal.profiling_modal>{{$t('offer_delivery.show_profiling')}}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item disabled>{{ $t('offer_delivery.create_a_reminder') }}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item>{{ $t('offer_delivery.refresh') }}</b-dropdown-item>
                            <b-dropdown-item>{{ $t('offer_delivery.incomplete_a_reminder') }}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item>{{ $t('offer_delivery.close_project') }}</b-dropdown-item>
                            <b-dropdown-item>{{ $t('offer_delivery.open_project') }}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item>{{ $t('offer_delivery.show_used_test_ids') }}</b-dropdown-item>
                            <b-dropdown-item>{{ $t('offer_delivery.list_refno') }}</b-dropdown-item>
                            <b-dropdown-item disabled>{{ $t('offer_delivery.delete_participation_records') }}</b-dropdown-item>
                          </b-dropdown>
                        </h3>
                        <div class="separator separator-dashed mt-10 mb-5"></div>
                        <b-table
                            :bordered="table.bordered"
                            :outlined="table.outlined"
                            :small="table.small"
                            :hover="table.hover"
                            :fixed="table.fixed"
                            :items="table.items4"
                            :head-variant="table.headvariant"
                        ></b-table>
                        <b-modal id="internal_test_post" :cancel-title="$t('general.cancel')" :ok-title="$t('general.close')" :title="$t('tests.groups')">
                           <div class="row">
                             <div class="col-xl-12">
                               <b-form-group>
                                 <b-form-select
                                     v-model="test_group_selected"
                                     :options="test_groups"
                                     class="form-control form-control-solid"
                                     size="sm">
                                 </b-form-select>
                               </b-form-group>
                             </div>
                           </div>
                          <div class="row" v-if="test_group_selected != null">
                             <div class="col-xl-6">
                               <b-form-group>
                                 <b-form-input class="form-control form-control-solid" type="date"></b-form-input>
                               </b-form-group>
                             </div>
                             <div class="col-xl-6">
                               <b-form-group>
                                 <b-form-input class="form-control form-control-solid" type="time"></b-form-input>
                               </b-form-group>
                             </div>
                            <div class="col-xl-12">
                              <b-button @click="SendIntervalTest" variant="outline-secondary"><i class="fa-plus fa"></i> {{$t('general.add')}}</b-button>
                            </div>
                            <div class="col-xl-12" v-if="test_interval_status != null">
                              <div class="separator separator-dashed mt-5 mb-5"></div>
                              <div class="p-3 bg-secondary progress-bar-striped" style="min-height: 170px;">
                                <p>Gönderi kaydı ekleniyor... Tamam</p>
                                <p>Mesajlar ekleniyor...</p>
                              </div>
                            </div>
                           </div>
                        </b-modal>
                      </div>
                      <div class="col-md-6">
                        <h3 class="font-size-lg text-dark font-weight-bold">
                          <span>{{ $t('offer_delivery.customer_test_deliveries') }}</span>
                          <b-dropdown id="dropdown-1" class="fa-pull-right" :text="$t('offer_delivery.action')" size="sm">
                            <b-dropdown-item v-b-modal.customer_test_post>{{ $t('offer_delivery.add_customer_test_post') }}</b-dropdown-item>
                            <b-dropdown-item>{{ $t('offer_delivery.start') }}</b-dropdown-item>
                            <b-dropdown-item disabled>{{ $t('offer_delivery.stop') }}</b-dropdown-item>
                            <b-dropdown-item>{{ $t('general.delete') }}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item>{{ $t('offer_delivery.edit') }}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item v-b-modal.load_data>{{ $t('offer_delivery.show_loaded_data') }}</b-dropdown-item>
                            <b-dropdown-item v-b-modal.profiling_modal>{{$t('offer_delivery.show_profiling')}}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item disabled>{{ $t('offer_delivery.create_a_reminder') }}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item>{{ $t('offer_delivery.refresh') }}</b-dropdown-item>
                            <b-dropdown-item>{{ $t('offer_delivery.incomplete_a_reminder') }}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item>{{ $t('offer_delivery.close_project') }}</b-dropdown-item>
                            <b-dropdown-item>{{ $t('offer_delivery.open_project') }}</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item>{{ $t('offer_delivery.show_used_test_ids') }}</b-dropdown-item>
                            <b-dropdown-item>{{ $t('offer_delivery.list_refno') }}</b-dropdown-item>
                            <b-dropdown-item disabled>{{ $t('offer_delivery.delete_participation_records') }}</b-dropdown-item>
                          </b-dropdown>
                        </h3>
                        <div class="separator separator-dashed mt-10 mb-5"></div>
                        <b-table
                            :bordered="table.bordered"
                            :outlined="table.outlined"
                            :small="table.small"
                            :hover="table.hover"
                            :fixed="table.fixed"
                            :items="table.items4"
                            :head-variant="table.headvariant"
                        ></b-table>
                        <b-modal id="customer_test_post" :cancel-title="$t('general.cancel')" :ok-title="$t('general.close')" :title="$t('tests.groups')">
                          <div class="row">
                            <div class="col-xl-12">
                              <b-form-group>
                                <b-form-select
                                    v-model="test_group_selected"
                                    :options="test_groups"
                                    class="form-control form-control-solid"
                                    size="sm">
                                </b-form-select>
                              </b-form-group>
                            </div>
                          </div>
                          <div class="row" v-if="test_group_selected != null">
                            <div class="col-xl-6">
                              <b-form-group>
                                <b-form-input class="form-control form-control-solid" type="date"></b-form-input>
                              </b-form-group>
                            </div>
                            <div class="col-xl-6">
                              <b-form-group>
                                <b-form-input class="form-control form-control-solid" type="time"></b-form-input>
                              </b-form-group>
                            </div>
                            <div class="col-xl-12">
                              <b-button @click="SendIntervalTest" variant="outline-secondary"><i class="fa-plus fa"></i> {{$t('general.add')}}</b-button>
                            </div>
                            <div class="col-xl-12" v-if="test_interval_status != null">
                              <div class="separator separator-dashed mt-5 mb-5"></div>
                              <div class="p-3 bg-secondary progress-bar-striped" style="min-height: 170px;">
                                <p>Gönderi kaydı ekleniyor... Tamam</p>
                                <p>Mesajlar ekleniyor...</p>
                              </div>
                            </div>
                          </div>
                        </b-modal>
                      </div>
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-12">
                            <h3 class="font-size-lg text-dark font-weight-bold">
                              <span>{{ $t('offer_delivery.delivery_reports') }}</span>
                              <b-form-group class="form-inline fa-pull-right">
                                <b-input-group>
                                  <b-form-select
                                      size="sm"
                                      v-model="offer_delivery_report_filter_selected"
                                      :options="offer_delivery_report_filter"></b-form-select>
                                  <b-input-group-append>
                                    <b-button class="btn-success fa-pull-right" size="sm"><i class="far fa-file-excel"></i> Excel'e aktar</b-button>
                                  </b-input-group-append>
                                </b-input-group>
                              </b-form-group>
                            </h3>
                            <div class="separator separator-dashed mt-10 mb-5"></div>
                            <data-table
                                :items="table.delivery_report"
                                :fields="report.delivery_report_fields"
                                :paginate="false"
                                page.sync="3"
                                perPage.sync="10"
                            ></data-table>

                            <b-modal id="delivery_report" size="lg" title="Detaylı Rapor" hide-footer>
                              <b-table
                                  :bordered="table.bordered"
                                  :outlined="table.outlined"
                                  :small="table.small"
                                  :hover="table.hover"
                                  :fixed="table.fixed"
                                  :items="table.items7"
                                  :head-variant="table.headvariant"
                              ></b-table>
                            </b-modal>
                          </div>
                        </div>
                      </div>
                    </div>

                    <b-modal id="load_data" size="lg" hide-footer :title="$t('offer_delivery.uploaded_data')">
                      <b-table
                          :bordered="table.bordered"
                          :outlined="table.outlined"
                          :hover="table.hover"
                          :no-border-collapse="table.noCollapse"
                          :items="table.items6"
                          :head-variant="table.headVariant"
                          :table-variant="table.tableVariant"
                      ></b-table>
                    </b-modal>
                    <b-modal id="profiling_modal" size="lg" hide-footer :title="$t('offer_delivery.profiling')">
                      <div class="profiling_response" v-html="ChangeJson(query)"></div>
                      <div class="separator separator-dashed mt-5 mb-5"></div>
                      <div class="profiling_count">
                        <strong>{{ $t('general.total') }}</strong>
                        <strong class="fa-pull-right" v-html="profiling_count"></strong>
                      </div>
                    </b-modal>

                    <b-row>
                      <b-col md="12">
                        <highcharts :options="sendChartOptions"></highcharts>
                      </b-col>
                    </b-row>

                    <div class="separator separator-dashed separator-border-2 mb-5 mt-5"></div>

                    <b-row>
                      <b-col md="12">
                        <b-form-group class="fa-pull-right">
                          <b-form-select size="sm" v-model="report_type_selected" :options="report_types"></b-form-select>
                        </b-form-group>
                      </b-col>
                      <b-col md="12" v-if="report_type_selected == 'Yaş Raporu'">
                        <b-row>
                          <b-col md="3">
                            <b-card title="Yaş Raporu">
                              <b-card-text>
                                <b-row>
                                  <b-col md="6">18-24 Yaş</b-col>
                                  <b-col md="6" class="text-right">30</b-col>
                                  <b-col md="12"><div class="separator separator-dashed separator-border-1 mb-1 mt-1"></div></b-col>
                                  <b-col md="6" >25-34 Yaş</b-col>
                                  <b-col md="6" class="text-right">60</b-col>
                                  <b-col md="12"><div class="separator separator-dashed separator-border-1 mb-1 mt-1"></div></b-col>
                                  <b-col md="6">35-44 Yaş</b-col>
                                  <b-col md="6" class="text-right">110</b-col>
                                  <b-col md="12"><div class="separator separator-dashed separator-border-1 mb-1 mt-1"></div></b-col>
                                  <b-col md="6">45-54 Yaş</b-col>
                                  <b-col md="6" class="text-right">20</b-col>
                                  <b-col md="12"><div class="separator separator-dashed separator-border-1 mb-1 mt-1"></div></b-col>
                                  <b-col md="6">55+ Yaş</b-col>
                                  <b-col md="6" class="text-right">12</b-col>
                                </b-row>
                              </b-card-text>
                            </b-card>
                          </b-col>
                          <b-col md="9">
                            <highcharts :options="ageChartOptions"></highcharts>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col md="12" v-if="report_type_selected == 'Şehir Raporu'">
                        <b-row>
                          <b-col md="3">
                            <b-card title="Şehir Raporu">
                              <b-card-text>
                                <b-row>
                                  <b-col md="6">Ankara</b-col>
                                  <b-col md="6" class="text-right">110</b-col>
                                  <b-col md="12"><div class="separator separator-dashed separator-border-1 mb-1 mt-1"></div></b-col>
                                  <b-col md="6" >İstanbul</b-col>
                                  <b-col md="6" class="text-right">120</b-col>
                                  <b-col md="12"><div class="separator separator-dashed separator-border-1 mb-1 mt-1"></div></b-col>
                                  <b-col md="6">Gaziantep</b-col>
                                  <b-col md="6" class="text-right">30</b-col>
                                  <b-col md="12"><div class="separator separator-dashed separator-border-1 mb-1 mt-1"></div></b-col>
                                  <b-col md="6">Samsun</b-col>
                                  <b-col md="6" class="text-right">25</b-col>
                                  <b-col md="12"><div class="separator separator-dashed separator-border-1 mb-1 mt-1"></div></b-col>
                                  <b-col md="6">Balıkesir</b-col>
                                  <b-col md="6" class="text-right">90</b-col>
                                </b-row>
                              </b-card-text>
                            </b-card>
                          </b-col>
                          <b-col md="9">
                            <highcharts :options="cityChartOptions"></highcharts>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col md="12" v-if="report_type_selected == 'Cinsiyet Raporu'">
                        <b-row>
                          <b-col md="3">
                            <b-card title="Şehir Raporu">
                              <b-card-text>
                                <b-row>
                                  <b-col md="6">Kadın</b-col>
                                  <b-col md="6" class="text-right">120</b-col>
                                  <b-col md="12"><div class="separator separator-dashed separator-border-1 mb-1 mt-1"></div></b-col>
                                  <b-col md="6" >Erkek</b-col>
                                  <b-col md="6" class="text-right">90</b-col>
                                </b-row>
                              </b-card-text>
                            </b-card>
                          </b-col>
                          <b-col md="9">
                            <highcharts :options="genderChartOptions"></highcharts>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>

                    <div class="separator separator-dashed separator-border-2 mb-5 mt-5"></div>

                    <b-row class="mt-10">
                      <b-col md="12">
                        <highcharts :title="$t('reports.read_report_title')" :options="readChartOptions"></highcharts>
                      </b-col>
                    </b-row>

                    <div class="separator separator-dashed separator-border-2 mb-5 mt-5"></div>

                    <b-row class="mt-10">
                      <b-col md="12">
                        <highcharts :title="$t('reports.click_report_title')" :options="clickChartOptions"></highcharts>
                      </b-col>
                    </b-row>
                  </div>
                  <!--end: Wizard Step 4-->

                  <!--begin: Wizard Actions -->
                  <div class="d-flex justify-content-between border-top pt-10">
                    <div class="mr-2">
                      <button
                          class="btn btn-light-primary font-weight-bold text-uppercase px-9 py-4"
                          data-wizard-type="action-prev"
                      >
                        {{ $t('offer_delivery.prev') }}
                      </button>
                    </div>
                    <div>
                      <button
                          v-on:click="submit"
                          class="btn btn-success font-weight-bold text-uppercase px-9 py-4"
                          data-wizard-type="action-submit"
                      >
                        {{ $t('general.save') }}

                      </button>
                      <button
                          class="btn btn-primary font-weight-bold text-uppercase px-9 py-4"
                          data-wizard-type="action-next"
                      >
                        {{ $t('offer_delivery.next') }}
                      </button>
                    </div>
                  </div>
                  <!--end: Wizard Actions -->
                </form>
                <!--end: Wizard Form-->
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Bpdy-->
      </div>
      <!--end: Wizard-->
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-4.scss";
</style>


<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";
import Swal from "sweetalert2";
import VueQueryBuilder from 'vue-query-builder';
import {Chart} from 'highcharts-vue'
import { PrismEditor } from "vue-prism-editor";
import vMultiselectListbox from 'vue-multiselect-listbox'
import { highlight, languages } from "prismjs/components/prism-core";
import DataTable from "@/assets/components/dataTable/DataTable";
import Profiling from "@/view/pages/profiling/Profiling";
import "vue-prism-editor/dist/prismeditor.min.css";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css"; // import syntax highlighting styles
import 'vue-multiselect-listbox/dist/vue-multi-select-listbox.css';

export default {
  name: "offersDetails",
  components: { VueQueryBuilder, highcharts: Chart,PrismEditor,vMultiselectListbox, DataTable, Profiling},
  data(){
    return {
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 15,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'voter_id', label: 'Voter Identifier', sortable: false},
          {key: 'no', label: 'Gönderi Numarası', sortable: true},
          {key: 'gender', label: 'Cinsiyet', sortable: true},
          {key: 'age', label: 'Yaş', sortable: true},
          {key: 'city', label: 'Şehir', sortable: true},
          {key: 'status', label: 'Anket Durumu', sortable: true},
          {key: 'point', label: 'Yüklenen Puan', sortable: true},
          {key: 'start', label: 'Ankete Gidiş', sortable: true},
          {key: 'end', label: 'Anketten Dönüş', sortable: true},
          {key: 'time', label: 'Anket Süresi', sortable: true},
          {key: 'test_status', label: 'Test Durumu', sortable: true},
        ],
        delivery_report_fields : [
          {key: 'delivery_report_action', label: 'İşlem', sortable: false},
          {key: 'surveyResult', label: 'Anket Sonucu', sortable: true},
          {key: 'loadedPoint', label: 'Yüklenen Puan', sortable: true},
          {key: 'count', label: 'Miktar', sortable: true},
          {key: 'totalLoadedPoint', label: 'Toplam Y.Puan', sortable: true},
        ]
      },
      code: '<!DOCTYPE html>\n' +
          '<html>\n' +
          '<body>\n' +
          '\n' +
          '<div style="height:50px; background-color:#1abc9c;border-top-right-radius:5px;border-top-left-radius:5px;">\n' +
          '  <h1 class="pt-3 text-center" style=\'color: #fff;\'>Napolyon.com</h1>\n' +
          '</div>\n' +
          '<h3 class="text-center pt-5">Napolyon kod önizlemesi</h3>\n' +
          '\n' +
          '</body>\n' +
          '</html>',
      lineNumbers: true,
      profiling_labels : {
        matchType : this.$t('profiling.matchType'),
        matchTypes : [
          {"id": "all", "label": this.$t('profiling.all')},
          {"id": "any", "label": this.$t('profiling.any')}
        ],
        addRule: this.$t('profiling.addRule'),
        removeRule : "&times;",
        addGroup : this.$t('profiling.addGroup'),
        removeGroup: "&times;",
        textInputPlaceholder: "value",
      },
      profiling_count : 0,
      rules : [],
      form : {
        cart_name : '13947 - Bilyoner 2020 Pazar Araştırması',
        date : '2020-12-15',
        survey_score : true,
        project : 'P12928W1',
        participants : 'P12928W1',
        completion : 1000,
        screen_out : 10,
        cup : 10,
        extra_points : 0,
        number_of_people: 0,
        profile_fullness : true,
        live_pool : true,
        rule_1 : null,
        rule_2 : null,
        rule_3 : null,
        submissions : null,
        including_excluding : 1,
        user_excluding : 1,
        option_selected : ['QF'],
        search_settings : null,
        search_settings_1 : null,
        popup_status : 'Göster',
      },
      links: [
        { link: 'http://survey.mind-station.com/survey/selfserve/55e/2011100?list=0&pin=055ASDA5A5S4D&NAP={MGUID}' },
        { link: 'http://survey.mind-station.com/survey/selfserve/55e/2011100?list=0&pin=055ASDA5A5S4D&NAP={MGUID}' },
        { link: 'http://survey.mind-station.com/survey/selfserve/55e/2011100?list=0&pin=055ASDA5A5S4D&NAP={MGUID}' },
        { link: 'http://survey.mind-station.com/survey/selfserve/55e/2011100?list=0&pin=055ASDA5A5S4D&NAP={MGUID}' },
        { link: 'http://survey.mind-station.com/survey/selfserve/55e/2011100?list=0&pin=055ASDA5A5S4D&NAP={MGUID}' },
        { link: 'http://survey.mind-station.com/survey/selfserve/55e/2011100?list=0&pin=055ASDA5A5S4D&NAP={MGUID}' },
        { link: 'http://survey.mind-station.com/survey/selfserve/55e/2011100?list=0&pin=055ASDA5A5S4D&NAP={MGUID}' },
        { link: 'http://survey.mind-station.com/survey/selfserve/55e/2011100?list=0&pin=055ASDA5A5S4D&NAP={MGUID}' },
        { link: 'http://survey.mind-station.com/survey/selfserve/55e/2011100?list=0&pin=055ASDA5A5S4D&NAP={MGUID}' },
        { link: 'http://survey.mind-station.com/survey/selfserve/55e/2011100?list=0&pin=055ASDA5A5S4D&NAP={MGUID}' },
        { link: 'http://survey.mind-station.com/survey/selfserve/55e/2011100?list=0&pin=055ASDA5A5S4D&NAP={MGUID}' },
        { link: 'http://survey.mind-station.com/survey/selfserve/55e/2011100?list=0&pin=055ASDA5A5S4D&NAP={MGUID}' },
        { link: 'http://survey.mind-station.com/survey/selfserve/55e/2011100?list=0&pin=055ASDA5A5S4D&NAP={MGUID}' },
      ],
      search_settings : ['Liste İçinde Ara', 'Listeyi Hariç Tut'],
      search_settings_1 : ['Liste İçinde Ara', 'Listeyi Hariç Tut'],
      including_excluding : ['Gönderimler İçinde Ara', 'Gönderimleri Hariç Tut'],
      submissions_options : ['QF', 'SNT', 'OPN', 'HARİÇ'],
      survey_score : true,
      completion_status : null,
      screen_out_status : null,
      cup_status : null,
      number_of_people_status : null,
      extra_points_status : null,
      random_point_question : true,
      participants: [{ text: this.$t('general.select'), value: null } , 'P12928W1','P12928W2', 'P12928W3', 'P12928W4', 'P12928W5'],
      project: [{ text: this.$t('general.select'), value: null } , 'P12928W1','P12928W2', 'P12928W3', 'P12928W4', 'P12928W5'],
      submissions: [{text: this.$t('general.select'), value: null }, 'Deneme - Reklam Maili Gönderimi', '12901 - Consumer Research'],
      user_excluding: ['Araştırma ve Reklam Firmaları', 'Sen de Söyle', 'TUAD ve Reklamcılar Derneği'],
      table : {
        bordered : true,
        outlined : true,
        small : true,
        fixed : true,
        hover : true,
        headvariant : 'light',
        items: [
          { 'Link Adı': 'SLINK', 'Link URL': "SurveyLink", '': "" },
          { 'Link Adı': 'SLINK', 'Link URL': "SurveyLink", '': "" },
          { 'Link Adı': 'SLINK', 'Link URL': "SurveyLink", '': "" },
        ],
        items2 : [
          { 'E': 'SLINK', 'SurveyLink': "https://www.twitter.com/sonnapolyon", '': "" },
          { 'E': 'SLINK', 'SurveyLink': "http://www.napolyon.com/Hesabim", '': "" },
          { 'E': 'SLINK', 'SurveyLink': "http://www.napolyon.com", '': "" },
        ],
        items3 : [
          { 'Durum': 'New', 'ID': "96.721", 'Adet': '42', 'Okunan' : '21', 'Tamamlanan' : '21', 'Başlangıç' : '8.12.2020', 'Bitiş' : '' },
          { 'Durum': '.', 'ID': "", 'Adet': '', 'Okunan' : '', 'Tamamlanan' : '',  'Başlangıç' : '', 'Bitiş' : '' },
          { 'Durum': '.', 'ID': "", 'Adet': '', 'Okunan' : '', 'Tamamlanan' : '',  'Başlangıç' : '', 'Bitiş' : '' },
          { 'Durum': '.', 'ID': "", 'Adet': '', 'Okunan' : '', 'Tamamlanan' : '',  'Başlangıç' : '', 'Bitiş' : '' },
          { 'Durum': '.', 'ID': "", 'Adet': '', 'Okunan' : '', 'Tamamlanan' : '',  'Başlangıç' : '', 'Bitiş' : '' },
        ],
        items4 : [
          { 'Durum': '.', 'ID': "", 'Adet': '', 'Okunan' : '', 'Tamamlanan' : '',  'Başlangıç' : '', 'Bitiş' : '' },
          { 'Durum': '.', 'ID': "", 'Adet': '', 'Okunan' : '', 'Tamamlanan' : '',  'Başlangıç' : '', 'Bitiş' : '' },
          { 'Durum': '.', 'ID': "", 'Adet': '', 'Okunan' : '', 'Tamamlanan' : '',  'Başlangıç' : '', 'Bitiş' : '' },
          { 'Durum': '.', 'ID': "", 'Adet': '', 'Okunan' : '', 'Tamamlanan' : '',  'Başlangıç' : '', 'Bitiş' : '' },
          { 'Durum': '.', 'ID': "", 'Adet': '', 'Okunan' : '', 'Tamamlanan' : '',  'Başlangıç' : '', 'Bitiş' : '' },
        ],
        items5 : [
          { 'Uyarılar': '.' },
          { 'Uyarılar' : '.'},
          { 'Uyarılar' : '.'}
        ],
        items6 : [
          {'Email' : 'engintepecam@gmail.com', 'GSM' : '', 'LinkUrl' : '', 'SentDate' : '', 'OpenedDate' : '', 'ErrorText' : '', 'ErrorDate' : ''},
          {'Email' : 'engintepecam@gmail.com', 'GSM' : '', 'LinkUrl' : '', 'SentDate' : '', 'OpenedDate' : '', 'ErrorText' : '', 'ErrorDate' : ''},
          {'Email' : 'engintepecam@gmail.com', 'GSM' : '', 'LinkUrl' : '', 'SentDate' : '', 'OpenedDate' : '', 'ErrorText' : '', 'ErrorDate' : ''},
          {'Email' : 'engintepecam@gmail.com', 'GSM' : '', 'LinkUrl' : '', 'SentDate' : '', 'OpenedDate' : '', 'ErrorText' : '', 'ErrorDate' : ''},
          {'Email' : 'engintepecam@gmail.com', 'GSM' : '', 'LinkUrl' : '', 'SentDate' : '', 'OpenedDate' : '', 'ErrorText' : '', 'ErrorDate' : ''},
          {'Email' : 'engintepecam@gmail.com', 'GSM' : '', 'LinkUrl' : '', 'SentDate' : '', 'OpenedDate' : '', 'ErrorText' : '', 'ErrorDate' : ''},
          {'Email' : 'engintepecam@gmail.com', 'GSM' : '', 'LinkUrl' : '', 'SentDate' : '', 'OpenedDate' : '', 'ErrorText' : '', 'ErrorDate' : ''},
          {'Email' : 'engintepecam@gmail.com', 'GSM' : '', 'LinkUrl' : '', 'SentDate' : '', 'OpenedDate' : '', 'ErrorText' : '', 'ErrorDate' : ''},
          {'Email' : 'engintepecam@gmail.com', 'GSM' : '', 'LinkUrl' : '', 'SentDate' : '', 'OpenedDate' : '', 'ErrorText' : '', 'ErrorDate' : ''},
          {'Email' : 'engintepecam@gmail.com', 'GSM' : '', 'LinkUrl' : '', 'SentDate' : '', 'OpenedDate' : '', 'ErrorText' : '', 'ErrorDate' : ''}
        ],
        delivery_report : [
          {'surveyResult' : '', 'loadedPoint' : '0', 'count' : '7', 'totalLoadedPoint' : '0'},
          {'surveyResult' : 'CO', 'loadedPoint' : '1000', 'count' : '201', 'totalLoadedPoint' : '201000'},
          {'surveyResult' : 'QF', 'loadedPoint' : '0', 'count' : '144', 'totalLoadedPoint' : '0'},
          {'surveyResult' : 'SO', 'loadedPoint' : '10', 'count' : '17', 'totalLoadedPoint' : '170'},
        ],
        items7 : [
          {'WaveID' : '6557', 'DeliveryID' : '97299', 'CallbackResult' : 'Anket Dolduruluyor', 'count' : '7'},
          {'WaveID' : '6557', 'DeliveryID' : '97299', 'CallbackResult' : 'CO', 'count' : '201'},
          {'WaveID' : '6557', 'DeliveryID' : '97299', 'CallbackResult' : 'QF', 'count' : '144'},
          {'WaveID' : '6557', 'DeliveryID' : '97299', 'CallbackResult' : 'SO', 'count' : '17'},
        ],
        special_area_items : [
          { 'Alan': '..', '..': "..", '': "" },
          { 'Alan': '..', '..': "..", '': "" },
          { 'Alan': '..', '..': "..", '': "" },
        ]
      },
      rule_2 : {
        1 : [{ text: this.$t('general.select'), value: null } , {value : 1, text : 'Eğitim'}, {value : 2, text : 'Hobi'}], //profil
      },
      rule_3 : {
        1 : [{ text: this.$t('general.select'), value: null } , {value : 1, text : 'En son mezun olduğunuz eğitim kurumu'}, {value : 2, text : 'İlkokulunuzun Adı'}],
        2 : [{ text: this.$t('general.select'), value: null } , {value : 3, text : 'Hangi spor dallarıyla ilgileniyorsunuz?'}, {value : 4, text : 'Boş vakitlerinizde ne yaparsınız?'}],
      },
      rule_4 : {
        1 : [{ text: this.$t('general.select'), value: null } , {value : 1, text : 'İlkokul'}, {value : 2, text : 'Ortaokul'}, {value : 2, text : 'Lise'}, {value : 2, text : 'Üniversite'}],
        2 : [{ text: this.$t('general.select'), value: null } , {value : 1, text : 'Menderes İlköğretim Okulu'}, {value : 2, text : 'Nene Hatun İlk Öğretim Okulu'}],
        3 : [{ text: this.$t('general.select'), value: null } , {value : 1, text : 'Futbol'}, {value : 2, text : 'Basketbol'}, {value : 2, text : 'Tenis'}, {value : 2, text : 'Koşu'}],
        4 : [{ text: this.$t('general.select'), value: null } , {value : 1, text : 'Kitap okurum'}, {value : 2, text : 'Gezerim'}],
      },
      rule_options : [{ text: this.$t('general.select'), value: null } , { value : 1, text : 'Profil'}],
      rule2_options : [{ text: this.$t('general.select'), value: null }],
      rule3_options : [{ text: this.$t('general.select'), value: null }],
      BuilderShow:false,
      query: {},
      ageChartOptions: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        title: {
          text: this.$t('reports.age_report_title')
        },
        credits: false,
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y:.1f}'
            }
          }
        },
        colors: ['#26527C','#9E8665','#151D30', '#336996', '#2970B7', '#243055', '#C8A679', '#E4C593'],
        series: [{
          name: 'Oran',
          colorByPoint: true,
          data: [{
            name: '18-24 Yaş',
            y: 30,
            sliced: true,
            selected: true
          }, {
            name: '25-34 Yaş',
            y: 60
          }, {
            name: '35-44 Yaş',
            y: 110
          }, {
            name: '45-54 Yaş',
            y: 20
          }, {
            name: '55+ Yaş',
            y: 12
          }]
        }]
      },
      cityChartOptions: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        title: {
          text: this.$t('reports.city_report_title')
        },
        credits: false,
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y:.1f}'
            }
          }
        },
        colors: ['#26527C','#9E8665','#151D30', '#336996', '#2970B7', '#243055', '#C8A679', '#E4C593'],
        series: [{
          name: 'Oran',
          colorByPoint: true,
          data: [{
            name: 'İstanbul',
            y: 120,
            sliced: true,
            selected: true
          }, {
            name: 'Samsun',
            y: 25
          }, {
            name: 'Balıkesir',
            y: 90
          }, {
            name: 'Gaziantep',
            y: 30
          }, {
            name: 'Ankara',
            y: 110
          }]
        }]
      },
      genderChartOptions: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        title: {
          text: this.$t('reports.gender_report_title')
        },
        credits: false,
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y:.1f}'
            }
          }
        },
        colors: ['#26527C','#9E8665','#151D30', '#336996', '#2970B7', '#243055', '#C8A679', '#E4C593'],
        series: [{
          name: 'Oran',
          colorByPoint: true,
          data: [{
            name: 'Kadın',
            y: 120,
            sliced: true,
            selected: true
          }, {
            name: 'Erkek',
            y: 90
          }]
        }]
      },
      sendChartOptions: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        title: {
          text: this.$t('reports.send_report_title')
        },
        credits: false,
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y:.1f}'
            }
          }
        },
        colors: ['#26527C','#9E8665','#151D30', '#336996', '#2970B7', '#243055', '#C8A679', '#E4C593'],
        series: [{
          name: 'Tip',
          colorByPoint: true,
          data: [{
            name: 'OPN',
            y: 130,
            sliced: true,
            selected: true
          }, {
            name: 'COPN',
            y: 120
          }]
        }]
      },
      readChartOptions: {
        chart: {
          type: 'column'
        },
        title: {
          text: this.$t('reports.read_report_title')
        },
        xAxis: {
          categories: [
            '04.12.2020',
            '05.12.2020',
            '06.12.2020',
            '07.12.2020',
            '08.12.2020',
            '09.12.2020',
            '10.12.2020'
          ],
          crosshair: true
        },
        credits: false,
        yAxis: {
          min: 0,
          title: {
            text: this.$t('reports.number_of_read')
          },
          gridLineColor: 'transparent',
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        colors: ['#26527C','#9E8665','#151D30', '#336996', '#2970B7', '#243055', '#C8A679', '#E4C593'],
        series: [{
          name: 'Tekil',
          data: [49.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6]

        }, {
          name: 'Kümül',
          data: [83.6, 78.8, 98.5, 93.4, 106.0, 84.5, 105.0]
        }]
      },
      clickChartOptions: {
        chart: {
          type: 'column'
        },
        title: {
          text: this.$t('reports.click_report_title')
        },
        xAxis: {
          categories: [
            '04.12.2020',
            '05.12.2020',
            '06.12.2020',
            '07.12.2020',
            '08.12.2020',
            '09.12.2020',
            '10.12.2020'
          ],
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('reports.number_of_click')
          },
          gridLineColor: 'transparent',
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        credits: false,
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        colors: ['#26527C','#9E8665','#151D30', '#336996', '#2970B7', '#243055', '#C8A679', '#E4C593'],
        series: [{
          name: 'Tekil',
          data: [23.9, 59.5, 85.4, 99.2, 90.0, 30.0, 45.6]

        }, {
          name: 'Kümül',
          data: [23.6, 55.8, 43.5, 20.4, 34.0, 22.5, 45.0]
        }]
      },
      report_type_selected : 'Yaş Raporu',
      report_types : ['Yaş Raporu', 'Cinsiyet Raporu', 'Şehir Raporu'],
      multiselect_options : [],
      test_group_selected : null,
      test_groups : [
        { text: this.$t('tests.groups'), value: null },
        'Ayşegül Yürüdüm',
        'Bahar',
        'Barış Tuncaboylu',
        'Çağdaş Mert',
        'Emine',
        'Mujgan',
        'Napolyon',
        'Nermin'
      ],
      test_interval_status : null,
      offer_delivery_report_filter : [{ text: this.$t('general.select'), value: null } , "CO" , "QF" , "SO", "Tümü"],
      offer_delivery_report_filter_selected : null,
      random_survey_type : '',
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('offers.offers'), route: "offers" },
      { title: "Bilyoner 2020 Pazar Araştırması" }
    ]);

    // Initialize form wizard
    const wizard = new KTWizard("kt_wizard_v4", {
      startStep: 1, // initial active step number
      clickableSteps: true // allow step clicking
    });

    // Validation before going to next page
    wizard.on("beforeNext", function(/*wizardObj*/) {
      // validate the form and use below function to stop the wizard's step
      // wizardObj.stop();
    });

    // Change event
    wizard.on("change", function(/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });

    this.random_survey_type = this.random = Math.floor(Math.random() * (3 - 1 + 1)) + 1;

  },
  methods: {

    submissionChange(){
      this.multiselect_options = [
        '96592 // 12901 - Consumer Research',
        '96591 // 12901 - Consumer Research',
        '96590 // 12901 - Consumer Research',
        '96589 // 12901 - Consumer Research',
      ];
    },
    SendIntervalTest(){
      this.test_interval_status = true;
    },
    ChangeJson(query){
      var response = "";

      if (query.children){
        query.children.forEach((value, index) => {

          var question = value.query.operand;
          var reply = value.query.value;

          if (reply){

            if (question == 'En son mezun olduğunuz eğitim kurumu'){

              var q_group = [{value : 1, text : 'İlkokul'}, {value : 2, text : 'Ortaokul'}, {value : 3, text : 'Lise'}, {value : 4, text : 'Üniversite'}];

            }else if(question == 'Hangi spor dallarıyla ilgileniyorsunuz?'){

              var q_group = [ {value : 1, text : 'Futbol'}, {value : 2, text : 'Basketbol'}, {value : 3, text : 'Tenis'}, {value : 4, text : 'Koşu'}];

            }else{
              var q_group = [{value : 1, text : 'Kitap okurum'}, {value : 2, text : 'Gezerim'}];
            }

            q_group.forEach((value,index) => {
              if (value.value == reply){
                var reply_string = value.text;
                var card_html = '<div class="card mb-5"><div class="card-body"><h4 class="card-title">'+question+'</h4> <p class="card-text">'+reply_string+'</p></div></div>';
                response = response + card_html;

              }
            });
          }
        });
        this.profiling_count = 38;
        return response;
      }
    },
    highlighter(code) {
      return highlight(code, languages.js,'html'); //returns html
    },
    changeItRandom(data){
      this.number_of_people_status = !data;
      this.extra_points_status = !data;
    },
    changeIt(data) {

      this.completion_status = !data;
      this.screen_out_status = !data;
      this.cup_status = !data;
      //this.$set(this.form,input,!data)
    },
    getRule2(data){

      if (data === null){
        this.rule2_options = [{ text: this.$t('general.select'), value: null }];
        this.rule3_options = [{ text: this.$t('general.select'), value: null }];
        this.form.rule_2 = null;
        this.form.rule_3 = null;
        this.BuilderShow = false;
      }else{
        this.rule2_options = this.rule_2[data];
      }

    },
    getRule3(data){
      this.BuilderShow = false;
      this.rule3_options = this.rule_3[data];
    },
    getRule4(data){
      this.rules = [{
        type : 'radio',
        addRule: this.$t('profiling.addRule'),
        id: "profiles",
        label: "En son mezun olduğunuz eğitim kurumu",
        choices: [
          {value : 1, label : 'İlkokul'},
          {value : 2, label : 'Ortaokul'},
          {value : 3, label : 'Lise'},
          {value : 4, label : 'Üniversite'}
        ]
      },{
          type : 'radio',
          addRule: this.$t('profiling.addRule'),
          id: "profiles_1",
          label: "Hangi spor dallarıyla ilgileniyorsunuz?",
          choices: [
            {value : 1, label : 'Futbol'},
            {value : 2, label : 'Basketbol'},
            {value : 3, label : 'Tenis'},
            {value : 4, label : 'Koşu'}
          ]
        }]
      this.BuilderShow = true;
    },
    submit: function(e) {
      e.preventDefault();
      Swal.fire({
        title: "",
        text: "Güncelleme başarıyla kaydedildi.",
        icon: "success",
        confirmButtonClass: "btn btn-secondary",
        confirmButtonText: "Tamam"
      });
    }
  }
};
</script>
<style>
.vqb-rule{
  margin: 20px 0;
  padding: 15px 10px;
}
.vqb-rule .form-inline > label{
  justify-content: left;
  padding-bottom: 10px;
}
.vqb-rule .form-inline > .close{
  position: absolute;
  right: 10px;
  top: 10px;
}
.vqb-rule .form-check-inline{
  justify-content: left;
}
.vqb-rule .form-inline{
  display: block;
  padding-left: 15px;
}
.vqb-group-heading{
  padding: 10px 30px;
}
.imac{
  background-image: url("../../../assets/media/project-logos/imac.png");
  background-size: cover;
  height: 453px;
  margin: auto;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
#result{
  padding: 30px;
}
@media (max-width: 400px) {
  .imac{
    height: 235px;
  }
}
@media (min-width: 401px) and (max-width: 500px) {
  .imac{
    height: 315px;
  }
}
@media (min-width: 501px) and (max-width: 601px) {
  .imac{
    height: 315px;
  }
}
</style>
<style lang="scss">
.my-editor {
  background: #e7e9f1;
  color: #ccc;
  height: 450px;

  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}

.prism-editor__textarea:focus {
  outline: none;
}

.height-300 {
  height: 300px;
}
.msl-searchable-list__items{
  border :1px solid #e2e2e2;
  border-radius: 5px;
}
.msl-searchable-list__item{
  background: #f3f6f9;
  border-bottom: 1px solid #e4e4e4;
}
.msl-search-list-input{
  display: none;
}
.msl-multi-select{
  width: 100%;
}
</style>